import { render } from "./ResultBanner.vue?vue&type=template&id=f3c6e558&scoped=true"
import script from "./ResultBanner.vue?vue&type=script&lang=js"
export * from "./ResultBanner.vue?vue&type=script&lang=js"

import "./ResultBanner.vue?vue&type=style&index=0&id=f3c6e558&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c6e558"]])

export default __exports__